$(document).ready(() => {
    let options = {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        prevArrow: $('.custom-slick-arrow.slick-prev'),
        nextArrow: $('.custom-slick-arrow.slick-next'),
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    }

    $('.js-slider').each((index, slider) => {
        if ($(slider).closest('.js-tab-item') && $(slider).closest('.js-tab-item').index() > 0) {
            let initialised = false;
            $(slider).closest('.js-tab-item').on('tab.opened', () => {
                if (!initialised) {
                    initialised = true
                    $(slider).slick(options)
                }
            })
        } else {
            $(slider).slick(options)
        }
    });
})

